/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseSocial from 'scripts/social/base';

export default BaseSocial.extend(
    {
        init: function() {
            this._super();
            this.apiUrl = this.appConfig.urls.api.instagram.apiUrl;
        },

        isApiAvailable: function() {
            return Boolean(window.instgrm);
        },

        create: function(element, params, callback) {
            this.initialize();
            this.socialAwaiting.then(
                function() {
                    var $element = this.$(element);
                    $element.html(params.embed.html);

                    if (window.instgrm.Embeds) {
                        window.instgrm.Embeds.process();
                    }

                    if (callback) {
                        callback();
                    }
                }.bind(this),
            );
        },

        getDataWithCallback: function(params, callback) {
            this.initialize();
            this.socialAwaiting.then(
                function() {
                    can.ajax({
                        url: this.appConfig.urls.api.instagram.oembed,
                        dataType: 'json',
                        data: {
                            url: can.sub(
                                this.appConfig.urls.api.instagram.data,
                                {
                                    socialId: params.socialID,
                                },
                            ),
                            maxwidth: '770',
                            hidecaption: true,
                            omitscript: true,
                        },
                        success: (data) => callback(data),
                        error: function(error) {
                            console.error(
                                'error loading instagram card data',
                                error,
                            );
                        },
                    });
                }.bind(this),
            );
        },

        getUserDataWithCallback: function(userId, callback) {
            this.initialize();
            this.socialAwaiting.then(
                function() {
                    can.ajax({
                        url: can.sub(
                            this.appConfig.urls.api.instagram.userData,
                            {
                                userId,
                            },
                        ),
                        dataType: 'json',
                        success: (data) => callback(data.user),
                        error: function(error) {
                            console.error(
                                'error loading instagram user data',
                                error,
                            );
                        },
                    });
                }.bind(this),
            );
        },
    },
    {},
);
